import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const UpdateNotification = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(10);
  const registrationRef = useRef(null);
  const updateTimerRef = useRef(null);

  const activateUpdate = () => {
    if (updateTimerRef.current) clearInterval(updateTimerRef.current);
    const waitingWorker = registrationRef.current?.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      return;
    }
    window.location.reload();
  };

  useEffect(() => {
    const handleUpdate = (event) => {
      registrationRef.current = event.detail?.registration || null;
      setSecondsRemaining(10);
      setShowNotification(true);
    };

    window.addEventListener('appUpdateAvailable', handleUpdate);

    // Check for pending updates on load
    const checkForPendingUpdate = () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          if (registration.waiting) {
            handleUpdate({ detail: { registration } });
          }
        });
      }
    };

    checkForPendingUpdate();

    return () => {
      window.removeEventListener('appUpdateAvailable', handleUpdate);
    };
  }, []);

  useEffect(() => {
    if (!showNotification) return undefined;
    updateTimerRef.current = setInterval(() => {
      setSecondsRemaining((value) => {
        if (value <= 1) {
          activateUpdate();
          return 0;
        }
        return value - 1;
      });
    }, 1000);
    return () => clearInterval(updateTimerRef.current);
  }, [showNotification]);

  if (!showNotification) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] w-[calc(100%-2rem)] max-w-md rounded-lg border border-purple-200 bg-white p-4 shadow-xl dark:border-purple-900 dark:bg-slate-800" role="alert" aria-live="assertive">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-purple-100 text-[#752F87] dark:bg-purple-950 dark:text-purple-300">
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900 dark:text-white">A required update is ready</p>
          <p className="mt-1 text-xs leading-5 text-gray-600 dark:text-gray-300">The portal will refresh automatically in {secondsRemaining}s to apply the latest business-critical changes. Your sign-in session will be kept.</p>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;